import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import ReactShowMoreText from "react-show-more-text";
import Slider from "react-slick";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { getCookie } from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";

const BooksDetails = () => {
  ChangeTitle("Books Details");
  const bookId = getCookie("bookId");
  const [booksDetails, setBooksDetails] = useState({});

  // Book List API Call
  const viewBookDetail = async (taxserviceId, currency) => {
    const param = {
      bookId: bookId,
    };

    console.log(param);

    var response = await postData("book/detail", param, apiHeader(false));

    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setBooksDetails(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewBookDetail(bookId);
  }, [bookId]);

  console.log("booksDetailsbooksDetails",booksDetails);
  

  const productDetails = [
    {
      src: toAbsoluteUrl("media/img/icon/basic/user.svg"),
      title1: "Publisher",
      title2: booksDetails && booksDetails.publisher && booksDetails.publisher,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/user.svg"),
      title1: "Author",
      title2:
        booksDetails && booksDetails.authorName && booksDetails.authorName,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/slider-horizontal.svg"),
      title1: "Language",
      title2:
        booksDetails &&
        booksDetails.languageDetail &&
        booksDetails.languageDetail.name,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/calendar.svg"),
      title1: "Date of publication",
      title2:
        booksDetails &&
        booksDetails.dateOfPublication &&
        booksDetails.dateOfPublication,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/book.svg"),
      title1: "Subject",
      title2: booksDetails && booksDetails.subject && booksDetails.subject,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/star.svg"),
      title1: "Edition",
      title2: booksDetails && booksDetails.edition && booksDetails.edition,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/keyboard.svg"),
      title1: "ISBN",
      title2: booksDetails && booksDetails.isbnNo && booksDetails.isbnNo,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/slider-horizontal.svg"),
      title1: "No. of page",
      title2: booksDetails && booksDetails.noOfPages && booksDetails.noOfPages,
    },
  ];

  const settings = {
    slidesPerRow: 1,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    nextArrow: (
      <div>
        <div className="relative top-[-3rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max shadow-lg main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="relative top-[-3rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[1rem] xs:left-0 w-max shadow-lg main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="w-full p-[5%] bg-yellow min-h-screen section-book-details">
        <div className="xxl:container mx-auto">
          <div className="w-full flex flex-col lg:flex-row mb-[5%] gap-10 sec-bd">
            <div className="w-[35%] sbd-part1">
              <img
                className="w-full rounded-[2rem]"
                src={
                  booksDetails &&
                  booksDetails.bookImage &&
                  booksDetails.bookImage
                }
                alt=""
              />
            </div>
            <div className="lg:w-[65%] sbd-part2">
              <h1 className="w-full mb-[1%] sbdp2-title">
                {booksDetails && booksDetails.title && booksDetails.title}
              </h1>
              {/* <p className="mb-[3%]">
              <ReactShowMoreText
                lines={2}
                more="View More"
                less="View Less"
                className="sbdp2-p"
                expanded={false}
              >
                This handbook covers the Securities and Exchange Board of
                India's (SEBI) regulatory framework for the Takeover
                Regulations. Structured into four comprehensive divisions, it
                covers the SEBI (Substantial Acquisition of Shares and Takeover)
                This handbook covers the Securities and Exchange Board of
                India's (SEBI) regulatory framework for the Takeover
                Regulations. Structured into four comprehensive divisions, it
                covers the SEBI (Substantial Acquisition of Shares and Takeover)
                This handbook covers the Securities and Exchange Board of
                India's (SEBI) regulatory framework for the Takeover
                Regulations. Structured into four comprehensive divisions, it
                covers the SEBI (Substantial Acquisition of Shares and Takeover)
              </ReactShowMoreText>
            </p> */}
              {/* <div className="w-full mb-[5%] flex gap-5 sbdp2-btns">
                <a
                  href={
                    booksDetails && booksDetails.content && booksDetails.content
                  }
                  target="_blank"
                  className="w-max py-[2%] px-[5%] sbdp2-btn"
                >
                  View content
                </a>
                <a
                  href={
                    booksDetails &&
                    booksDetails.sampleChapter &&
                    booksDetails.sampleChapter
                  }
                  target="_blank"
                  className="w-max py-[2%] px-[5%] sbdp2-btn"
                >
                  Sample chapter
                </a>
              </div> */}
              <div className="w-full mb-[5%] relative sbdp2-product-details sbdp2pd">
                <h1 className="mb-[5%] sbdp2pd-title">Product details</h1>
                <div className="w-[75%] sm:w-[80%] lg:w-[90%] lg:ml-[1%] xl:ml-[2%] md:w-full mx-auto">
                  <Slider
                    className="w-full h-max lg:w-[88%] xl:w-[98%] mx-auto cursor-pointer"
                    {...settings}
                  >
                    {productDetails.map((data, i) => (
                      <>
                        <div className="flex flex-col items-center sbdp2pd-box">
                          <img
                            className="mb-[5%] sbdp2pdb-icon"
                            src={data.src}
                            alt=""
                          />
                          <h1 className="text-center sbdp2pdb-title1">
                            {data.title1}
                          </h1>
                          <h1 className="text-center sbdp2pdb-title2">
                            {data.title2}
                          </h1>
                        </div>
                      </>
                    ))}
                  </Slider>
                </div>
              </div>
              <div className="sbdp2-description sbdp2d">
                <h1 className="mb-[1%] sbdp2d-title">Description</h1>
                <p className="mb-[2%] sbdp2d-p">
                  <ReactShowMoreText
                    lines={5}
                    more="View more"
                    less="View less"
                    className=""
                    expanded={false}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          booksDetails &&
                          booksDetails.description &&
                          booksDetails.description,
                      }}
                    />
                  </ReactShowMoreText>
                </p>
                {/* <p className="sbdp2d-p">
                It is structured into four comprehensive divisions, providing
                extensive analysis and practical guidance on the subject:
              </p>
              <ul className="ml-[2.5%] mb-[2%] sbdp2d-p">
                <li>
                  Division One – SEBI (Substantial Acquisition of Shares and
                </li>
                <li>
                  Takeover) Regulations 2011 Division Two – Master Circular for
                </li>
                <li>
                  Takeover Regulations Division Three – Informal Guidance on
                </li>
                <li>Takeover Regulations Division Four – Case Laws</li>
              </ul> */}
                {/* <ReactShowMoreText
                  lines={1}
                  more="View More"
                  less="View Less"
                  className="sbdp2-p sbdp2d-p"
                  expanded={false}
                >
                  The Present Publication is the Latest Edition, updated till
                  10th May 2024 The Present Publication is the Latest Edition,
                  updated till 10th May 2024 The Present Publication is the
                  Latest Edition, updated till 10th May 2024
                </ReactShowMoreText> */}
              </div>
            </div>
          </div>
          <div className="w-full book-about">
            <h1 className="mb-[2%] ba-title">About the author</h1>
            <div className="w-full flex flex-col lg:flex-row gap-10 lg:gap-20">
              <div className="w-[30%] md:w-[20%] lg:w-[10%] ba-part1">
                <img
                  className="w-full"
                  src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
                  alt=""
                />
              </div>
              <div className="w-full lg:w-[90%] ba-part2">
                <p className="mb-[1%] bap2-p">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        booksDetails &&
                        booksDetails.aboutAuthor &&
                        booksDetails.aboutAuthor,
                    }}
                  />
                </p>
                {/* <h1 className="mb-[1%] bap2-title">
                GCC Law Help Editorial Board
              </h1> */}
                {/* <p className="mb-[1%] bap2-p">
                At the heart of GCC Law Help Publication is the Research &
                Editorial Team, composed of Chartered Accountants, Company
                Secretaries, and Lawyers. This esteemed group, guided by
                Editor-In-Chief Mrs. Bhavika Jawaharani, is committed to
                delivering content with accuracy and reliability.
              </p> */}
                {/* <h1 className="bap2-title">Mission and Methodology:</h1>
              <ul className="ml-[2%] mb-[1%] bap2-p bap2-ul1">
                <li>
                  Six Sigma Principles: Our mission is rooted in Six Sigma
                  methodology. We aim to eliminate errors and uphold the highest
                  standards of excellence in all publications and research
                  outputs.
                </li>
              </ul>
              <h1 className="mb-[1%] bap2-title">
                Core Guidelines for Content Development:
              </h1>
              <ul className="ml-[2%] flex flex-col gap-5 mb-[2%] bap2-p bap2-ul2">
                <li>
                  Sourcing: &nbsp;
                  <span>
                    All statutory materials are sourced exclusively from
                    authorized and credible sources, ensuring the integrity of
                    the information provided.
                  </span>
                </li>
                <li>
                  Current Awareness: &nbsp;
                  <span>
                    We prioritize informing readers of the latest legislative
                    developments, ensuring timely and relevant content.
                  </span>
                </li>
                <li>
                  Analytical Insights: &nbsp;
                  <span>
                    We specialize in crafting analytical pieces on topical,
                    contentious, and impactful issues, aiding readers in
                    comprehensively understanding the nuances and implications
                    of recent events.
                  </span>
                </li>
                <li>
                  Clarity and Accuracy: &nbsp;
                  <span>
                    Every publication is thorough, precise, and articulated,
                    serving as a reliable reference for complex subjects
                  </span>
                </li>
                <li>
                  Evidence-based Referencin: &nbsp;
                  <span>
                    Assertions and analyses are meticulously backed with
                    references to relevant sections, circulars, notifications,
                    or citations, enhancing the content's credibility.
                  </span>
                </li>
                <li>
                  Quality and Consistency: &nbsp;
                  <span>
                    Adherence to the golden rules of grammar, style, and
                    consistency is non-negotiable, ensuring a seamless and
                    engaging reading experience.
                  </span>
                </li>
                <li>
                  Accessibility: &nbsp;
                  <span>
                    The choice of font and size across all print and digital
                    mediums is dictated by legibility and consistency, making
                    information accessible to all readers. This team is the
                    cornerstone of our commitment to delivering unparalleled
                    accuracy and reliability in our content, ensuring that every
                    publication meets the highest standards of excellence.
                  </span>
                </li>
              </ul> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BooksDetails;
